import request from '@/router/axios'

const API = '/api/produce/kanban/transport-plan-top10-customers'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

function n(v) {
  const x = Number(v)
  return Number.isFinite(x) ? x : 0
}

function normalize(d) {
  if (!d || typeof d !== 'object') return { year: null, metric: 'plan', items: [] }
  return {
    year: d.year,
    metric: d.metric || 'plan',
    items: (d.items || []).map((it) => ({
      custName: it.custName,
      planTotal: n(it.planTotal),
      executeTotal: n(it.executeTotal),
      rankValue: it.rankValue != null ? n(it.rankValue) : 0,
      completionRatePercent: it.completionRatePercent != null ? n(it.completionRatePercent) : null
    }))
  }
}

export function fetchTransportPlanTop10Customers(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: {
      year: params.year != null ? parseInt(String(params.year), 10) : undefined,
      businessType: params.businessType,
      metric: params.metric || 'plan'
    }
  })
    .then(unwrap)
    .then(normalize)
}
